export const RETRY_FETCH = 'products/RETRY_FETCH';

export const DELETE_PRODUCT = 'products/DELETE';

export const TOGGLE_VISIBILITY = 'products/TOGGLE_VISIBILITY';
